"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFeatureApp = exports.getCachedModule = void 0;
const oneaudi_os_utils_1 = require("@oneaudi/oneaudi-os-utils");
// Loaded features will be noted for serialization
// This helps us preload features before hydration
const PRELOAD_FEATURES = {};
/**
 * Storage for caching feature apps before hydration starts
 */
const PRELOAD_CACHE = new Map();
function getCachedKey(lib, mod) {
    return `${lib}-${mod}`;
}
function getCachedModule(lib, mod) {
    const key = getCachedKey(lib, mod);
    if (PRELOAD_CACHE.has(key)) {
        return PRELOAD_CACHE.get(key);
    }
}
exports.getCachedModule = getCachedModule;
function cacheModule(lib, modName, mod) {
    const key = getCachedKey(lib, modName);
    PRELOAD_CACHE.set(key, mod?.default || mod);
}
async function loadFeatureApp(scope, derivedScopeFromSrc = '', mod, hydration = false) {
    // Initializes the share scope. This fills it with known provided modules from this build and all remotes
    await __webpack_init_sharing__('default');
    // Get MF container
    const global = window;
    // Try camelCase for backwards compatibility (TODO remove)
    const container = global[scope] ||
        // possibly fa-<name-doc>
        global[(0, oneaudi_os_utils_1.abbreviatedFA)(derivedScopeFromSrc || scope)] ||
        // @deprecated
        global[(0, oneaudi_os_utils_1.dashToCamel)(scope)];
    // Initialize the container, it may provide shared modules
    await container.init(__webpack_share_scopes__.default);
    // Get shared module
    const factory = await container.get(mod);
    // Initialize the module
    const Module = factory();
    if ((0, oneaudi_os_utils_1.isSSR)()) {
        // serialize preloaded features
        PRELOAD_FEATURES[`${scope}-${mod}`] = [scope, mod];
        injectMetadata();
    }
    else if (hydration) {
        cacheModule(scope, mod, await Module);
    }
    return Module;
}
exports.loadFeatureApp = loadFeatureApp;
function injectMetadata() {
    if ((0, oneaudi_os_utils_1.isSSR)()) {
        /**
         * create a script tag with information about FAs that need to be preloaded
         * before the site can be hydrated
         */
        const script = document.createElement('script');
        script.innerText = `window.__PRELOAD_FEATURES__ = ${JSON.stringify(PRELOAD_FEATURES)}`;
        script.dataset['featureapps'] = '1';
        // remote existing
        const existing = document.querySelector('script[data-featureapps="1"]');
        if (existing) {
            document.head.removeChild(existing);
        }
        // append to head
        document.head.appendChild(script);
    }
}
